import React from 'react'
import { useMutation } from "@tanstack/react-query"
import { updateNormalDistributionFetch } from "store/middlewares/assessment.crud"
import { toast } from 'react-toastify'
import { toastConfig } from 'config'

const useHeaderActionBtns = () => {

    const { mutateAsync: updateNormalDistribution, isPending } = useMutation({
        mutationFn: async () => {
            toast("העדכון מתבצע עבור כל המבדקים ומעדכן קצב ומספר מילים נכונות לדקה", toastConfig)
            await updateNormalDistributionFetch()
        },
        onSuccess: () => {
            toast('העדכון הסתיים בהצלחה!', toastConfig)
        },
        onError: () => {
            toast.error('תקלה במהלך העדכון', toastConfig)
        }
    })

    const headerBtns = React.useMemo(
        () =>
            [
                {
                    label: "חישוב נורמות עבור התפלגות נורמלית",
                    action: updateNormalDistribution,
                    loading: isPending
                }
            ],
        [isPending]
    )

    return headerBtns
}

export default useHeaderActionBtns